module.exports = __webpack_public_path__ + "img/logo2.e3287cc3.png";